<template>
  <el-dialog
    class="rc-dialog"
    title="学员导入"
    :visible.sync="dialogInfo.show"
    @close="closeDialog"
    :close-on-click-modal="false"
    destroy-on-close
    width="45%"
  >
    <el-form
      ref="curdForm"
      size="small"
      label-position="right"
      label-width="100px"
    >
      <el-form-item>
         <butn btntype="primary" title="下载模板" @click="downloadTemplate"></butn>
      </el-form-item>
      <el-form-item
        required
        label="附件："
        error="请上传附件"
        :show-message="file == null"
      >
        <upload v-model="file" ref="removeFile" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click="createData" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import vue from "@/main";
import { importEnroll } from "@/api/enrollOffline";
import Upload from "@/components/upload/excel";
import { studentsTemplate } from "@/assets/excel/index.js";
import { downloadByUrl } from "../../../../utils/common";
export default {
  components: { butn, Upload },
  props: {
    classId: {
      type: String,
      default: () => "",
    },
    dialogInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      file: null,
      EXCP: studentsTemplate,
    };
  },
  methods: {
    createData() {
      if (this.file != null) {
        let formData = new FormData();
        formData.append("classId", this.classId);
        formData.append("file", this.file);
        importEnroll(formData).then((res) => {
          if (res && res.code == 0) {
            if (res.data != null) {
              this.$message.error("导入包含错误数据，请检查");
              this.$router.push({
                path: "/excelError",
              });
              localStorage.setItem("errorExcelData", JSON.stringify(res.data));
              this.$emit("closeMember", true);
            } else {
              this.$message.success(res.msg);
              this.$emit("closeMember", true);
            }
          } else {
            this.$refs.removeFile.$refs.upload.uploadFiles.pop();
            this.file = null;
          }
        });
      }
    },
    closeDialog() {
      this.file = null;
      this.$emit("closeMember", false);
    },
    downloadTemplate() {
      downloadByUrl("", this.EXCP);
    }
  },
};
</script>

<style lang="scss" scoped></style>
